export default __webpack_public_path__ + "static/media/151-sit-down.5efa5b49.png";